import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { IconName } from '@lib/components/Modal/enums';

interface ConfirmationModalProps {
  cancelButtonLabel?: string;
  children?: React.ReactElement;
  confirmButtonLabel: string;
  description: React.ReactNode;
  icon: IconName;
  isOpen: boolean;
  modalBodyClassName?: string;
  modalContentClassName?: string;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
}

function ConfirmationModal({
  cancelButtonLabel,
  children,
  confirmButtonLabel,
  description,
  icon,
  isOpen,
  modalBodyClassName,
  modalContentClassName,
  onClose,
  onConfirm,
  title,
}: ConfirmationModalProps) {
  const { t } = useTranslation();
  const actionsArray = [
    <Button
      onClick={onClose}
      buttonType={ButtonTypes.secondaryOutlined}
      buttonText={cancelButtonLabel || t('cancel')}
      leftIcon="close"
      fullWidth
    />,
    <Button
      onClick={onConfirm}
      buttonType={ButtonTypes.primaryFilled}
      buttonText={confirmButtonLabel}
      leftIcon="check"
      fullWidth
    />,
  ];
  const actions = <ActionsRow actions={actionsArray} />;
  return (
    <Modal
      actions={actions}
      description={description}
      icon={icon}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      modalBodyClassName={modalBodyClassName}
      modalContentClassName={modalContentClassName}
    >
      {children}
    </Modal>
  );
}

export default ConfirmationModal;
